import React from 'react';

import { Flex } from '@chakra-ui/react';

import { MeshMavenWithHording } from 'assets/assetsV1/iconComponents/MeshMavenWithHording';

import BetaTag from 'uiToolkitV1/Tag/BetaTag';

const MeshMavenTitleComp = () => (
  <Flex alignItems="center" gap={2}>
    <MeshMavenWithHording boxSize="32px" />
    <span>Maven</span>
    <BetaTag />
  </Flex>
);

export default MeshMavenTitleComp;
